import React from 'react'
import { Divider, Grid } from "@mui/material"

import AlertsBaseDrawer from "Pages/ReportsAlerts/Alerts/Conditions/@components/Drawer"
import {
	AlertsComparator,
	AlertsComparatorUnit,
	AlertsComparatorValue,
	AlertsComparisonType,
	AlertsConditionName,
	AlertsDrawerBaseFooter,
	AlertsMainProviders,
	AlertsMoreFeatures,
	AlertsSameInsurance
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsMainSites from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Drawer/MainSites"
import AlertsSites from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Drawer/Sites"
import AlertsProviders from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Drawer/Providers"


export default function PriceComparisonDrawer({ onSubmitAlert, isLoading }) {

	return <AlertsBaseDrawer
		footer={<AlertsDrawerBaseFooter isLoading={isLoading} onSubmitAlert={onSubmitAlert}/>}
		content={<Grid container spacing={3}>
			<Grid item xs={12} data-tour-id="cond-pc-name">
				<AlertsConditionName/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pc-main-site">
				<AlertsMainSites/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pc-main-providers">
				<AlertsMainProviders/>
			</Grid>
			<Grid item xs={4} data-tour-id="cond-pc-comparator">
				<AlertsComparator/>
			</Grid>
			<Grid item xs={4} data-tour-id="cond-pc-comp-value">
				<AlertsComparatorValue/>
			</Grid>
			<Grid item xs={4} data-tour-id="cond-pc-comp-unit">
				<AlertsComparatorUnit/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pc-sites">
				<AlertsSites/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pc-providers">
				<AlertsProviders/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pc-comp-type">
				<AlertsComparisonType url={'comparison-type-price-comparison'}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pc-same-ins">
				<AlertsSameInsurance/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pc-more">
				<AlertsMoreFeatures/>
			</Grid>
		</Grid>}
	/>
}